import { connect } from 'react-redux';
import SearchProgressModal from './SearchProgressModal';

function mapStateToProps() {
  return {};
}

const mapActionToProps = {};

export default connect(mapStateToProps, mapActionToProps)(SearchProgressModal);
